document.addEventListener("DOMContentLoaded", function () {
	const blogInstaSlider = document.querySelectorAll(".blog-insta-slider");

	blogInstaSlider.forEach((slider) => {
		const swiper = new Swiper(slider, {
			direction: "horizontal",
			slidesPerView: "auto",
			spaceBetween: 5,
			grabCursor: true,
			loop: true,
			autoplay: {
				delay: 4500,
				disableOnInteraction: true,
			},
		});
	});
});
